import { DatasheetUpnListDto } from "@common/dto/datasheet/upn/list";

export const getUpns = (): Promise<Array<DatasheetUpnListDto>> => {
  return new Promise((resolve) => {
    resolve(
      [
        {
          id: 1,
          name: '1',
        },
        {
          id: 2,
          name: '2',
        },
        {
          id: 3,
          name: '3',
        },
        {
          id: 4,
          name: '4',
        },
        {
          id: 5,
          name: '5',
        },
      ]
    );
  });
};